<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.Emirate"
        [valueText]="form.controls.Emirate?.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown
        *ngIf="!isRegistered"
        formControlName="Emirate"
        identifier="Emirate"
        name="Emirate"
        key="UserProfile.Emirate"
        [items]="lookups.Emirates"
        [bindLabel]="defaultLookupDisplayProperty"
        (change)="onEmirateChange()"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.CompanyNameAr"
        [valueText]="form.controls.NameAr?.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isRegistered"
        formControlName="NameAr"
        identifier="NameAr"
        name="NameAr"
        key="UserProfile.CompanyNameAr"
        maxLength="200"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.CompanyNameEn"
        [valueText]="form.controls.NameEn?.value"
      >
      </app-bs-display>
      <bs-ng-text
        *ngIf="!isRegistered"
        formControlName="NameEn"
        identifier="NameEn"
        name="NameEn"
        key="UserProfile.CompanyNameEn"
        maxLength="200"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.LegalStatus"
        [valueText]="form.controls.LegalStatus?.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown
        *ngIf="!isRegistered"
        formControlName="LegalStatus"
        identifier="LegalStatus"
        name="LegalStatus"
        key="UserProfile.LegalStatus"
        [items]="lookups.LegalStatuses"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6">
      <app-bs-display
        *ngIf="isRegistered"
        key="UserProfile.LicenseIssuer"
        [valueText]="form.controls.LicenseIssuer?.value | lookup : lang"
      >
      </app-bs-display>
      <bs-ng-dropdown
        *ngIf="!isRegistered"
        formControlName="LicenseIssuer"
        identifier="LicenseIssuer"
        name="LicenseIssuer"
        key="UserProfile.LicenseIssuer"
        [items]="lookups.LicenseIssuers"
        [bindLabel]="defaultLookupDisplayProperty"
        (change)="onIssuerChange()"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6">
      <bs-ng-dropdown
        formControlName="LicenseType"
        identifier="LicenseType"
        name="LicenseType"
        key="UserProfile.LicenseType"
        [items]="lookups.LicenseTypes"
        [bindLabel]="defaultLookupDisplayProperty"
      >
      </bs-ng-dropdown>
    </div>

    <div class="col-md-6">
      <bs-ng-text
        formControlName="LicenseNumber"
        identifier="LicenseNumber"
        name="LicenseNumber"
        key="UserProfile.LicenseNumber"
        maxLength="200"
        (change)="validateLicense()"
      >
      </bs-ng-text>
    </div>

    <div class="col-md-6">
      <bs-ng-date
        formControlName="LicenseIssuanceDate"
        identifier="LicenseIssuanceDate"
        key="UserProfile.LicenseIssuanceDate"
        name="LicenseIssuanceDate"
      >
      </bs-ng-date>
    </div>

    <div class="col-md-6">
      <bs-ng-date
        formControlName="LicenseExpiryDate"
        identifier="LicenseExpiryDate"
        key="UserProfile.LicenseExpiryDate"
        name="LicenseExpiryDate"
      >
      </bs-ng-date>
    </div>
  </div>
</form>
